var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIntelligentCall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 13C4 10.2386 6.23858 8 9 8V8C11.7614 8 14 10.2386 14 13V15C14 16.1046 13.1046 17 12 17H6C4.89543 17 4 16.1046 4 15L4 13Z",
    fill: "#7947C9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_13361_4809)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1 5C1 3.89543 1.89543 3 3 3H11C14.3137 3 17 5.68629 17 9V13C17 14.1046 16.1046 15 15 15H3C1.89543 15 1 14.1046 1 13V5Z",
    fill: "#7947C9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M5.46014 5.30957H4.71014C4.29593 5.30957 3.96014 5.64536 3.96014 6.05957V6.80957C3.96014 7.22378 4.29593 7.55957 4.71014 7.55957H5.46014C5.87436 7.55957 6.21014 7.22378 6.21014 6.80957V6.05957C6.21014 5.64536 5.87436 5.30957 5.46014 5.30957Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M5.46014 9.05957H4.71014C4.29593 9.05957 3.96014 9.39536 3.96014 9.80957V10.5596C3.96014 10.9738 4.29593 11.3096 4.71014 11.3096H5.46014C5.87436 11.3096 6.21014 10.9738 6.21014 10.5596V9.80957C6.21014 9.39536 5.87436 9.05957 5.46014 9.05957Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M9.20996 5.30957H8.45996C8.04575 5.30957 7.70996 5.64536 7.70996 6.05957V6.80957C7.70996 7.22378 8.04575 7.55957 8.45996 7.55957H9.20996C9.62417 7.55957 9.95996 7.22378 9.95996 6.80957V6.05957C9.95996 5.64536 9.62417 5.30957 9.20996 5.30957Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.20996 9.05957H8.45996C8.04575 9.05957 7.70996 9.39536 7.70996 9.80957V10.5596C7.70996 10.9738 8.04575 11.3096 8.45996 11.3096H9.20996C9.62417 11.3096 9.95996 10.9738 9.95996 10.5596V9.80957C9.95996 9.39536 9.62417 9.05957 9.20996 9.05957Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M12.9603 5.30957H12.2103C11.7961 5.30957 11.4603 5.64536 11.4603 6.05957V6.80957C11.4603 7.22378 11.7961 7.55957 12.2103 7.55957H12.9603C13.3745 7.55957 13.7103 7.22378 13.7103 6.80957V6.05957C13.7103 5.64536 13.3745 5.30957 12.9603 5.30957Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_13361_4809",
    x: -3,
    y: -1,
    width: 24,
    height: 20,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_13361_4809"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntelligentCall);
export default __webpack_public_path__ + "static/media/intelligentCall.3d3b7e7cd60840dda8b1f61063328705.svg";
export { ForwardRef as ReactComponent };